import { type ThemeOptions } from '@mui/material';

export const typography: ThemeOptions['typography'] = {
  fontFamily: 'Manrope, sans-serif',
  h1: {
    fontSize: '2.625rem', // 42px
    fontWeight: 600,
    lineHeight: '48px',
  },
  h2: {
    fontSize: '2.25rem', // 36px
    fontWeight: 600,
    lineHeight: '40px',
  },
  h3: {
    fontSize: '2rem', // 32px
    fontWeight: 600,
    lineHeight: '40px',
  },
  h4: {
    fontSize: '1.375rem', // 22px
    fontWeight: 600,
    lineHeight: '28px',
  },
  h5: {
    fontSize: '1.25rem', // 20px
    fontWeight: 600,
    lineHeight: '30px',
  },
  h6: {
    fontSize: '1.125rem', // 18px
    fontWeight: 600,
    lineHeight: 1.5,
  },
  body1: {
    fontSize: '1rem', // 16px — P2
    fontWeight: 400,
    lineHeight: '24px',
  },
  body2: {
    fontSize: '0.75rem', // 12px — P5
    fontWeight: 400,
    lineHeight: '19px',
  },
};
